/**
 * @param {import("../../../../utils/router/Router").default} router
 */
export default function (router) {
  router.group(
    {
      path: "/alfred/hotels/:hotelId/services",
    },
    (router) => {
      router.push({
        id: "@api/hotel.service@search",
        path: "",
      });

      router.push({
        id: "@api/hotel.service@create",
        path: "",
      });

      router.group(
        {
          path: "/:hotelServiceId",
        },
        (router) => {
          router.push({
            id: "@api/hotel.service@view",
            path: "",
          });

          router.push({
            id: "@api/hotel.service@update",
            path: "",
          });

          router.push({
            id: "@api/hotel.service@delete",
            path: "",
          });

          router.group(
            {
              path: "/action",
            },
            (router) => {
              router.push({
                id: "@api/hotel.service@restore",
                path: "/restore",
              });
            },
          );
        },
      );
    },
  );
}
